<template>
  <div>
    <!-- 左中标题头 -->
    <!-- 组件1550b630-3dec-11ec-a2e6-953464dcce14开始-->
    <div
      id="item1550b630-3dec-11ec-a2e6-953464dcce14"
      :style="{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px',
        lineHeight: '1.5',
        color: '#ffffff',
        textAlign: 'center',
        textShadow: false ? '0px 0px 14px rgba(15, 146, 255,1)' : '',
      }"
      class="centertitle"
    >
      <p>求职数据统计（近五个月）</p>
    </div>

    <!-- 组件1550b630-3dec-11ec-a2e6-953464dcce14结束-->
    <!-- 左中echarts图展示区域 -->
    <!-- 组件a1c42d00-3deb-11ec-a2e6-953464dcce14开始-->
    <div id="leftCentershowWindow2">
      <div class="innerBox">
        <div id="leftCenterEchartsBox21"></div>
        <div id="leftCenterEchartsBox22"></div>
        <div id="leftCenterEchartsBox23"></div>
      </div>
    </div>
    <!-- 组件a1c42d00-3deb-11ec-a2e6-953464dcce14结束-->
    <!-- 左中容器背景图 -->
    <!-- 组件0c892655-9dbb-497c-bec9-239cca87c34a开始-->
    <!-- 外框背景图_中间发光 -->
    <div id="item0c892655-9dbb-497c-bec9-239cca87c34a">
      <img src="../../../assets/images/线框.png" alt="" :style="{ width: '100%', height: '100%' }" />
    </div>
    <!-- 组件0c892655-9dbb-497c-bec9-239cca87c34a结束-->
  </div>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios';
export default {
  mounted () {
    this.setEcharts('leftCenterEchartsBox21', 0)
    // this.setEcharts('leftCenterEchartsBox22', 1)
    // this.setEcharts('leftCenterEchartsBox23', 0)
  },
  data () {
    return {
      // 模拟数据
      resData: [
        {
          date: '2025-3-1', // 日期
          // totalPlanAmount: 63909.61, // 采购方式对应项目总预算
          // capitalSavingRate: 0.2572, // 采购方式对应资金节约率
          cNums:800, // 企业数量
          totalLastPrice: 47471.43 // 采购方式对应项目总成交（中标）金额
        },
        {
          date: '2025-3-2',
          totalPlanAmount: 402045.66,
          capitalSavingRate: 0.0996,
          cNums: 280,
          totalLastPrice: 362009.37
        },
        {
          date: '2025-3-3',
          totalPlanAmount: 72923.44,
          capitalSavingRate: 0.3032,
          cNums: 46,
          totalLastPrice: 50813.2
        },
        {
          date: '2025-3-4',
          totalPlanAmount: 731.43,
          capitalSavingRate: 0.0224,
          cNums: 13,
          totalLastPrice: 715.04
        },
        {
          date: '批量采购',
          totalPlanAmount: 253,
          capitalSavingRate: 0.0663,
          cNums: 5,
          totalLastPrice: 236.22
        },
        {
          date: '电子卖场',
          totalPlanAmount: 89.19,
          capitalSavingRate: 0.199,
          cNums: 2,
          totalLastPrice: 71.44
        },
        {
          date: '竞争性谈判',
          totalPlanAmount: 16707.31,
          capitalSavingRate: 0.1195,
          cNums: 20,
          totalLastPrice: 14710.59
        },
        {
          date: '定点采购',
          totalPlanAmount: 680.47,
          capitalSavingRate: 0.1982,
          cNums: 5,
          totalLastPrice: 545.6
        },
        {
          date: '邀请招标',
          totalPlanAmount: 5991.68,
          capitalSavingRate: 0.3084,
          cNums: 3,
          totalLastPrice: 4144
        },
        {
          date: '询价',
          totalPlanAmount: 679.72,
          capitalSavingRate: 0.282,
          cNums: 2,
          totalLastPrice: 488.01
        },
        {
          date: '网上竞价',
          totalPlanAmount: 49,
          capitalSavingRate: 0.5918,
          cNums: 1,
          totalLastPrice: 20
        }
      ],
      bannerIdex: 0 // 初始化banner的下标
    }
  },
  methods: {
    /*
      创建echarts图
      @param id: 要画echarts的容器
      @param flag: 统计项目的内容
      - flag = 1 : 统计内容为企业数量柱状图
      - flag = 0 : 统计内容为项目预算柱状图、中标金额柱状图和资金节约率折线图
    */
    async setEcharts (id) {
      // 根据id如果是图2展示企业数量和中标项目预算，否则展示中标金额和资金节约率
      const showEchartsData =[
            {
              name: '求职数据',
              type: 'line',
              yAxisIndex: 0,
              data: []
            }
          ]
      const xData = []
      await axios.get('https://work.ycrc88.com/api/getapi')
  .then(response =>{
    this.resData=response.data.resdata1
    console.log(response.data.resdata1)
    response.data.resdata1.forEach((item,index) => {
        xData.push(item.date)
        showEchartsData[0].data.push(item.cNums)
      })
  })
  .catch(error => console.error(error))
      console.log(this.resData)
      var chartDom = document.getElementById(id)
      var myChart = echarts.init(chartDom)
      var option
      option = {
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {
          //   type: 'cross',
          //   crossStyle: {
          //     color: '#999'
          //   }
          // }
        },
        toolbox: {
          // feature: {
          //   dataView: { show: true, readOnly: false },
          //   magicType: { show: true, type: ['line', 'bar'] },
          //   restore: { show: true },
          //   saveAsImage: { show: true }
          // }
        },
        legend: {
          data: ['求职数量'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          containLabel: false // 是否自适应x, y 轴文字的宽度
        },
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              interval: 0, // 全部展示
              rotate: '45' // x轴字体倾斜角度
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '投递数量变化',
            axisLabel: {
              formatter: '{value}',
              rotate: '45' 
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#375C77'
              }
            }
          },
          // {
          //   type: 'value',
          //   name: '每日数据',
          //   axisLabel: {
          //     formatter: '{value}'
          //   },
          //   splitLine: {
          //     show: false
          //   }
          // }
        ],
        series: showEchartsData
      }

      option && myChart.setOption(option)
    },
    /*
      banner滚动
      @param n: 当前展示的第几张图，从0开始
      @param bufferMove: 函数(能够实现元素的减速运动)
    */
    // changeBanner (n, bufferMove) {
    //   const bannerWrap = document.querySelector('.innerBox')
    //   if (n === 3) {
    //     bannerWrap.style.left = 0
    //     n = 1
    //   }
    //   bufferMove(
    //     bannerWrap,
    //     {
    //       left: -n * 450
    //     },
    //     30
    //   )
    // }
  }
}
</script>

<style scoped>
/* 背景图的位置及大小 */
#item0c892655-9dbb-497c-bec9-239cca87c34a {
  top: 320px;
  left: 20px;
  width: 530px;
  height: 300px;
}
/* 标题位置 */
#item1550b630-3dec-11ec-a2e6-953464dcce14 {
  top: 330px;
}
#leftCentershowWindow2 {
  position: absolute;
  left: 70px;
  top: 350px;
  width: 450px;
  height: 270px;
  overflow: hidden;
}
#leftCentershowWindow2 .innerBox {
  display: flex;
  position: absolute;
  top: 2px;
  left: 0px;
  height: 270px;
  width: 1350px;
}
#leftCentershowWindow2 .innerBox div {
  position: absolute;
  top: 0px;
  width: 450px;
  height: 270px;
  z-index: 8;
  opacity: 1;
  transform: rotate(0deg);
  background: rgba(255, 255, 255, 0);
  border: 0px solid #2ed64a;
  border-radius: 0px;
  padding: 0px;
}
#leftCenterEchartsBox21 {
  left: 0px;
}
#leftCenterEchartsBox22 {
  left: 450px;
}
#leftCenterEchartsBox23 {
  left: 900px;
}
</style>
